import { render } from "./AuthModal.vue?vue&type=template&id=d4f4da4a&scoped=true&ts=true"
import script from "./AuthModal.vue?vue&type=script&lang=ts"
export * from "./AuthModal.vue?vue&type=script&lang=ts"

import "./AuthModal.vue?vue&type=style&index=0&id=d4f4da4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f4da4a"]])

export default __exports__